<template>
  <LayoutShell>
    <slot />
  </LayoutShell>
</template>
